import { render, staticRenderFns } from "./addStore.vue?vue&type=template&id=5f3d9a24&scoped=true&"
import script from "./addStore.vue?vue&type=script&lang=js&"
export * from "./addStore.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f3d9a24",
  null
  
)

export default component.exports